import { ApiError } from "@/lib/apiClient";

export type DocSlot = "driverLicense" | "voidedCheck";

export const DOC_SLOT_ORDER: DocSlot[] = ["driverLicense", "voidedCheck"];

export const CONVERSION_ERROR_CODE = "DOCUMENT_CONVERSION_FAILED";

export const DOCUMENT_REQUIRED_CODE = "DOCUMENT_REQUIRED";

export const REUPLOAD_HINT = "Upload this file again.";

const SLOT_LABEL: Record<DocSlot, string> = {
  driverLicense: "driver's license",
  voidedCheck: "voided check",
};

const FIELD_TO_SLOT: Record<string, DocSlot> = {
  driverlicense: "driverLicense",
  driverlicenseimagebase64: "driverLicense",
  driverlicensefilename: "driverLicense",
  voidedcheck: "voidedCheck",
  voidcheck: "voidedCheck",
  voidedcheckimagebase64: "voidedCheck",
  voidcheckimagebase64: "voidedCheck",
  voidedcheckfilename: "voidedCheck",
  voidcheckfilename: "voidedCheck",
};

function stringList(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((v): v is string => typeof v === "string") : [];
}

function slotKeys(body: unknown): string[] {
  if (!body || typeof body !== "object") return [];
  const b = body as Record<string, unknown>;
  const keys: string[] = [];

  const additional = b.additionalData;
  if (additional && typeof additional === "object") {
    keys.push(...stringList((additional as Record<string, unknown>).failedFields));
  }

  if (b.errors && typeof b.errors === "object" && !Array.isArray(b.errors)) {
    keys.push(...Object.keys(b.errors as Record<string, unknown>));
  }
  keys.push(...stringList(b.documents));

  return keys;
}

export function failedDocSlots(e: unknown): DocSlot[] {
  if (!(e instanceof ApiError) || e.errorCode !== CONVERSION_ERROR_CODE) return [];
  const found = new Set<DocSlot>();
  for (const key of slotKeys(e.body)) {
    const slot = FIELD_TO_SLOT[key.toLowerCase()];
    if (slot) found.add(slot);
  }
  return DOC_SLOT_ORDER.filter((s) => found.has(s));
}

const REQUIRED_TO_SLOT: Record<string, DocSlot> = {
  driverlicense: "driverLicense",
  voidedcheck: "voidedCheck",
};

export function requiredDocSlots(e: unknown): DocSlot[] {
  if (!(e instanceof ApiError) || e.errorCode !== DOCUMENT_REQUIRED_CODE) return [];
  const found = new Set<DocSlot>();
  for (const key of slotKeys(e.body)) {
    const slot = REQUIRED_TO_SLOT[key.toLowerCase()];
    if (slot) found.add(slot);
  }
  return DOC_SLOT_ORDER.filter((s) => found.has(s));
}

export function conversionMessage(slots: DocSlot[]): string | null {
  const ordered = DOC_SLOT_ORDER.filter((s) => slots.includes(s));
  if (ordered.length === 0) return null;
  const names = ordered.map((s) => SLOT_LABEL[s]).join(" and ");
  return `We couldn't process your ${names}. Tap to upload again.`;
}
